export default __webpack_public_path__ + "static/media/scrollcard6.1404ed70.jpg";